import React from "react";
import {ISvgIconProps, SvgIcon} from "./svg-icon.component";

export const CheckMarkIcon: React.FC<ISvgIconProps> = (props) => {
    return (
        <SvgIcon size={1} fill={"none"} {...props} viewBox="0 0 13 9" ratio={13 / 9}>
            <path
                d="M11.9098 0.842269L11.904 0.835192L11.8976 0.828583C11.6809 0.604173 11.3324 0.603676 11.1151 0.827092L4.79442 7.17545L1.70209 4.06154C1.48482 3.838 1.13621 3.83845 0.91947 4.06291C0.706843 4.2831 0.706843 4.6304 0.91947 4.85059L0.919453 4.85061L0.921821 4.85299L4.09655 8.04988C4.28411 8.24336 4.53979 8.3399 4.77676 8.3399C5.03435 8.3399 5.27156 8.24118 5.45688 8.04998L11.8561 1.62273C12.0923 1.4038 12.0905 1.06059 11.9098 0.842269ZM4.87924 7.26087L4.87804 7.25966C4.87847 7.26008 4.87884 7.26049 4.87923 7.26089L4.87924 7.26087Z"
                fill={props.color? props.color: "currentColor"} stroke={props.color? props.color: "currentColor"} strokeWidth="0.48"/>
        </SvgIcon>
    )
}
